import DevelopersList from './DevelopersList.jsx';

import './developers-list-media-query.scss';

export default DevelopersList;
